export const ParticipantTypeEnumText = {
    teacher: "Teacher",
    student: "Student"
}